module.exports = __webpack_public_path__ + "static/media/step3-1.d95db917.png";